import React from "react";
import { getIcon } from "../utils/icons";
type PillProps = {
  icon: string;
  label: string;
  tone?: "light" | "dark";
};
export function Pill({
  icon,
  label,
  tone = "dark"
}: PillProps) {
  const Icon = getIcon(icon);
  const styles = tone === "dark" ? "bg-white/10 text-white ring-white/15" : "bg-navy/[0.05] text-navy ring-navy/10";
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide ring-1 ${styles}`} data-id="element-171" data-mp="n70wuz95uopr">
      <Icon className={`h-3.5 w-3.5 ${tone === "dark" ? "text-gold" : "text-gold-ink"}`} aria-hidden="true" data-id="element-172" data-mp="1ewvpp5w88wj6" />
      {label}
    </span>;
}